<template>
  <div id="text">

    <article class="message">
      <div class="message-body">
        <div class="title is-5">Line Chart</div>
        <div class="text">This line chart shows the aggregate of methods (scaled 1-5, from transparent to opaque); aesthetics, or language/visuals used (scaled 1-5, from impartial to sensational), and pragmatics, or sphere of impact (scaled 1-5, from public to private), across a sample of investigations between 2004 and 2019.</div>
        <div class="text"> An additional, fourth binary variable, gatekeeping, concerned with whether or not an investigation won an award(s), is presented as a number across the variables.</div>
        <div class="text">This chart allows the viewer to better explore how the nature of British investigative journalism may have changed across time.</div>
        <div class="text">It is proposed that interactive text boxes containing the details of each investigation will arise in mouse-over, and that further interactive materials (including bespoke videos and learning materials, concerning a top 10 canon in the field) may be made available.</div>
      </div>
    </article>

    <div class="chartWithOverlay">
          <GChart
                  type="LineChart"
                  :data="chartData"
                  :options="chartOptions"
                  style="width: 1200px; height: 600px;"
                  @ready="onChartReady"
                  ref="gChart"
          />
    </div>

    <div class="content">

      <div id="append" >Line graphs are conventionally associated with continuous, rather than discrete data, and so this may be seen as representing a sub-optimal means of presenting the data. However, where discrete data are aggregated, it may be argued that it may then serve as a proxy for an aspect of the <em>culture</em> of investigative journalism, a continuous phenomenon.</div>
      <strong>Variables:</strong>
     <ul>
       <li>Methods used (scaled 1-5; from transparent to opaque)</li>
       <li>Pragmatics involved (scaled 1-5; from public to private)</li>
       <li>Aesthetics (scaled 1-5; from impartial to sensational)</li>
       <li>Gatekeeping: did the investigation win any awards (1 or 0):</li>
     </ul>
    </div>


  </div>
</template>

<script>

    import { GChart } from "vue-google-charts";
    import  { dataService } from "../services/data.service";

    export default {
        name: "LineChart",
        props: {
          mydata : []
        },
        components: {
            GChart
        },
        data() {
            return {
                chartData: this.mydata,
                chartOptions: {
                    title: 'Events by year',
                    curveType: 'function',
                    lineWidth: 3,
                    annotations: {
                        style: 'line',
                        stem: { color: '#000000', length: 6 },
                        textStyle: { color: '#000000' }
                    },
                  width:1200,
                  height:600
                }
            };
        },
        methods: {
            onChartReady(chart, google) {
                // now we have google lib loaded. Let's create data table based using it.
                this.createDataTable(chart, google);
            },
            createDataTable(chart, google) {

                var data = new google.visualization.DataTable();
                data.addColumn('string', 'Year');
                data.addColumn('number', 'Method');
                data.addColumn('number', 'Pragmatics');
                data.addColumn('number', 'Aesthetics');
                data.addColumn({type:'number', role:'annotation'}); // annotation role col

                let rows = dataService.aggregateData(this.chartData);
                data.addRows(rows);

                var view = new google.visualization.DataView(data);
                chart.draw(view, this.chartOptions);
            }
        },
        mounted()  {
          console.log('line chart loaded');
        }
    }
</script>

<style scoped>

    .chartWithOverlay {
      /*  position: relative; */
        left: 20px;
        top: 20px;
        display: block;
        margin-bottom: 20px;
    }

    #text {
      width: 100%;
    }

    #append {
      padding-bottom: 30px;
    }

    .text {
      padding: 5px 0;
    }

    em {
      font-weight: 500
    }

</style>
